var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{class:{
    'p-0': _vm.$route.name === 'auth-login',
    'container-main': _vm.$route.name !== 'auth-login'
  }},[_c('confirmation'),_c('v-container',{class:{
      'p-0': _vm.$route.name === 'auth-login'
    },attrs:{"fluid":""}},[(_vm.$route.name !== 'auth-login' && _vm.$route.name !== 'submenu-menu')?_c('breadcrumbs'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }